<template>
  <div>
    <div class="ml-3 mb-12" :key="config.code" v-for="config in configs">
      <vs-divider position="left">
      <h2 class="mt-3">{{ config.title }}</h2>
      </vs-divider>
      <div class="mt-8 ml-5 flex">
      <vs-button :key="item.code" color="primary" type="filled" size="large" icon="list" v-for="item in config.list" class="mr-5" @click="goTo(item.path)">{{ item.title }}</vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import configs from '../../config/dataConfig'
export default {
  data() {
    return {
      configs
    }
  },
  methods: {
    goTo(route) {
      this.$router.replace(`/${this.$route.params.nameCompany}/${route}`).catch(() => {});
    }
  }
}
</script>

<style scoped>

</style>
